import { configureStore } from '@reduxjs/toolkit';
import configuratorReducer from './configuratorSlice';

export const store = configureStore({
  reducer: {
    configurator: configuratorReducer,
  }
})
